import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import CollectionCard from '../utils/CollectionCard';
import { Back, Home, HomeIcon, Next, Previous, Search } from '../HemeIconLibrary';
import { useSelector } from 'react-redux';
import { setAddToCart, updateItemCount, setCartAdded } from '../Store/reducers/orders';
import { useDispatch } from 'react-redux';
import BackCmp from '../components/BackCmp';
import { getAvailabeKitsAction } from '../Actions/orders';

import { Alert as BootstrapAlert } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import Button from '../utils/Button';

const itemsPerPage = 8;
const Collection = ({ storeItems }) => {
  const [search, setSearch] = useState('');
  const [items, setItems] = useState([]);
  const [count, setCount] = useState();
  const [filterData, setFilterData] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const dispatch = useDispatch();
  const addToCart = (data, status) => {
    dispatch(updateItemCount({ data: data, count: data.count ? data.count : 1 }));
    const getCartItemsFromLocal = localStorage.getItem('cart-item-ids');
    const ids = [];
    var concatenatedIds = '';
    for (var i = 0; i < data.count; i++) {
      ids.push(data.id);
    }
    concatenatedIds = ids.join(',');
    console.log('concatenatedIds', concatenatedIds);
    if (status === true) {
      localStorage.setItem('cart-item-ids', [getCartItemsFromLocal, concatenatedIds]);
    } else {
      localStorage.setItem(
        'cart-item-ids',
        getCartItemsFromLocal.split(',')?.filter((id) => id !== String(data.id)),
      );
    }
    dispatch(setAddToCart({ data, status }));
    dispatch(setCartAdded(true));
    setFilterData(
      filterData.map((up) => {
        if (up.id === data.id) {
          return {
            ...up,
            count: 1,
          };
        } else {
          return up;
        }
      }),
    );
  };
  console.log('r', filterData);
  const changeQuantity = (data, count) => {
    //dispatch(updateItemCount({ data: data, count: count }));
    setFilterData(
      filterData.map((up) => {
        if (up.id === data.id) {
          // if (count <= 999) {
          return {
            ...up,
            count: count,
          };
          // } else {
          //   return up;
          // }
        } else {
          return up;
        }
      }),
    );
  };

  useEffect(() => {
    if (items && items.length > 0) {
      const finalData = items?.filter((item) => item.name.toLowerCase().includes(search.toLowerCase()));
      setFilterData(finalData);
    }
  }, [search]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    callinit();
  }, [localStorage.getItem('portal-active-site-id')]);

  const callinit = async () => {
    const updaterCartonRefresh = await getAvailabeKitsAction(localStorage.getItem('portal-active-site-id'), true);
    if (updaterCartonRefresh && updaterCartonRefresh.data) {
      setItems(updaterCartonRefresh.data);
      let total = 1;
      if (updaterCartonRefresh.data && updaterCartonRefresh.data.length > 0) total = Math.ceil(updaterCartonRefresh.data.length / itemsPerPage);
      setTotalPages(total);
      let pageItems = splitData(updaterCartonRefresh.data);
      // var getCartItemsFromLocal = localStorage.getItem('cart-item-ids');
      // getCartItemsFromLocal = getCartItemsFromLocal?.split(',');
      setFilterData(
        pageItems?.map((item) => {
          return { ...item, count: 1 };
        }),
      );
    }
  };

  useEffect(() => {
    if (items.length > 0) {
      let pageItems = splitData(items);
      setFilterData(pageItems);
    }
  }, [page]);

  const splitData = (data) => {
    if (data != null) {
      const startIndex = (page - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      const pageItems = data.slice(startIndex, endIndex);

      return pageItems;
    } else {
      return null;
    }
  };

  return (
    <>
      <div className="max-w-[1440px] w-full min-h-screen mx-auto  pt-[79px] px-[24px] md:px-[40px] mb-[40px] md:mb-[112px]">
        <div className="flex items-center justify-between flex-wrap gap-6 mb-[29px]">
          <div className="flex items-center ">
            <BackCmp />
            <Link to="/" className="font-medium text-[13px] leading-6 text-black hover:text-primary1 m-0 no-underline">
              Home
            </Link>
            <div className=" w-[2px] h-4 bg-black mx-1" />
            <h5 className="font-medium text-[13px] leading-6 text-primary1 m-0">Collection Kits</h5>
          </div>

          <div className=" w-full sm:w-[307px] flex items-center justify-between gap-[10px] px-4 py-[13px] bg-white rounded-full shadow-mdShadow ">
            <input
              type="text"
              placeholder="Search..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              className="w-full outline-none border-0 text-[14px] leading-4 font-medium"
            />
            <Search color="#605DAF" />
          </div>
        </div>
        <div className="flex flex-wrap items-center justify-center md:justify-start w-full gap-x-12 gap-y-[35px] collection-card">
          {filterData ? (
            filterData?.length ? (
              filterData?.map((item) => <CollectionCard data={item} addToCart={addToCart} changeQuantity={changeQuantity} />)
            ) : (
              <>
                <BootstrapAlert variant="warning">No kits Available for selected Site</BootstrapAlert>
              </>
            )
          ) : (
            <div className="flex flex-wrap gap-[40px]">
              <div className="w-[305px] min-h-[478px] rounded-[35px]">
                <Skeleton count="15" />
              </div>
              <div className="w-[305px] min-h-[478px] rounded-[35px]">
                <Skeleton count="15" />
              </div>
              <div className="w-[305px] min-h-[478px] rounded-[35px]">
                <Skeleton count="15" />
              </div>
              <div className="w-[305px] min-h-[478px] rounded-[35px]">
                <Skeleton count="15" />
              </div>
            </div>
          )}
        </div>
        <div className="ml-auto w-fit mt-10">
          <div className="">
            <div className="flex items-center gap-2 flex-wrap">
              <Button
                text="Previous"
                cta={() => {
                  if (items.length > 0) {
                    setPage((prevState) => prevState - 1);
                  }
                }}
                className={'kitButton'}
                disabled={!(page > 1)}
                bg="bg-primary1"
                color="text-white"
                Icon={<Previous />}
                type="submit"
              />
              <Link to="/">
                <Button text="Home" type="button" bg="bg-primary1" color="text-white" Icon={<HomeIcon />} />
              </Link>
              <Button
                text="Next"
                cta={() => {
                  if (items.length > 0) {
                    setPage((prevState) => prevState + 1);
                  }
                }}
                className={'kitButton'}
                disabled={page === totalPages}
                bg="bg-primary1"
                color="text-white"
                Icon={<Next />}
                type="submit"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Collection;
